export default {
  "b2b.navigation.title": "B2B Portal",
  "b2b.navigation.item.prehled": "Overview",
  "b2b.navigation.item.rezervace": "Reservations",
  "b2b.navigation.item.casovy-plan": "Timetable",
  "b2b.navigation.item.historie": "Request History",
  "b2b.navigation.item.rezervace.odbaveni": "Request Handling",
  "b2b.navigation.item.rezervace.vytvoreni": "New Reservation",
  "b2b.navigation.item.provozni-informace": "Operational Information",
  "b2b.navigation.item.administrace": "Administration",
  "b2b.navigation.item.administrace.zakaznici": "Customers",
  "b2b.navigation.item.administrace.zdroje": "Resources",
  "b2b.navigation.item.administrace.konfiguracni-parametry": "Parameters"
};
